<template>
  <v-chip :color="chipProps.color">{{ chipProps.text }}</v-chip>
</template>

<script>
import { cardExpireMonths, cardExpireToDate } from '@/utils/dateUtil'

export default {
  props: {
    card: Object,
  },
  computed: {
    chipProps() {
      if (!this.card) {
        return {
          text: 'カード未登録',
          color: 'error',
        }
      } else if (this.card.expire) {
        const expireMonths = cardExpireMonths(this.card.expire)
        const text = (msg) => {
          return `${msg} (${cardExpireToDate(this.card.expire)})`
        }
        if (expireMonths < 0) {
          return {
            text: text('カード期限切'),
            color: 'error',
          };
        } else if (expireMonths < 3) {
          return {
            text: text('カード期限近'),
            color: 'warning',
          };
        } else {
          return {
            text: text('カード登録済'),
            color: 'success',
          };
        }
      } else {
        return {
          text: 'カード期限不明',
          color: 'warning',
        };
      }
    },
  },
}
</script>